// extracted by mini-css-extract-plugin
module.exports = {"paginator":"IV3tjVK58cov2DEYN2_yq"};